function triggerReactChangeEvent(element, value) {
  var node;
  if (element instanceof $) {
    if (element.length == 0) return;
    node = element[0];
  } else if (element instanceof window.HTMLElement) {
    node = element;
  }

  var inputTypes = [
    window.HTMLInputElement,
    window.HTMLSelectElement,
    window.HTMLTextAreaElement
  ];

  var index = inputTypes.indexOf(node.__proto__.constructor);

  if (index > -1) {
    var eventType = (index == 1) ? 'change' : 'input';
    var setValue = Object.getOwnPropertyDescriptor(node.__proto__, 'value').set;
    var event = new Event(eventType, { bubbles: true });

    setValue.call(node, value);
    node.dispatchEvent(event);
  }
}

function simulateReactInputChange(element, value) {
  let node;

  if (element instanceof $) {
    if (element.length === 0) return;
    node = element[0];
  } else if (element instanceof window.HTMLElement) {
    node = element;
  }

  const inputTypes = [
    window.HTMLInputElement,
    window.HTMLSelectElement,
    window.HTMLTextAreaElement,
  ];

  const index = inputTypes.indexOf(node.__proto__.constructor);
  if (index > -1) {
    const eventType = index === 1 ? 'change' : 'input';
    const setValue = Object.getOwnPropertyDescriptor(node.__proto__, 'value').set;
    const event = new Event(eventType, { bubbles: true });

    // Asegúrate de convertir a string solo para el input
    setValue.call(node, String(value));
    node.dispatchEvent(event);
  }
}
//------------------MEDIDAS
function getTextWidth(text, font = 'bold 100px Arial') {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.font = font;
  const metrics = ctx.measureText(text);
  return metrics.width; // ancho en píxeles
}

function calcularAnchoEnMetros(texto, alturaEnMetros, font = 'bold 100px Arial') {
  const alturaFuentePx = parseFloat(font.match(/\d+/)[0]); // ej. 100 de '100px'
  const anchoPx = getTextWidth(texto, font);
  const escala = alturaEnMetros / alturaFuentePx; // metros por píxel
  const anchoEnMetros = anchoPx * escala;
  return anchoEnMetros;
}

// 🧪 Ejemplo:
const texto = 'IAGUAL';
const alturaMetros = 1; // tú decides la altura deseada
const fuente = 'bold 100px Arial';
//----------------------MEDIDAS

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  // Esperar a que el DOM esté listo
  $(document).ready(function() {
    var customSize = document.querySelector('.custom-size input');
  

      document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
  console.log('UpDATE', event.target)  
    var customText = $('.custom-text textarea');
    console.log(customText[0].value)

    const anchoCalculado = calcularAnchoEnMetros(customText[0].value, alturaMetros, fuente);

    console.log(`Ancho de "${texto}" con altura de ${alturaMetros}m: ${anchoCalculado.toFixed(2)}m`);
            if (customSize) {
      triggerReactChangeEvent(customSize, anchoCalculado);
              customSize.setAttribute('name', anchoCalculado);
    } else {
      console.warn('No se encontró el textarea dentro de .custom-size');
    }
  })

});


  
})

document.body.addEventListener('PRODUCT_BUILDER_OPTION_ACTIVATE', function(event) {
  console.log('Activate', event) 
})

document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
  // 1. Find the text the user is typing
  var customTextValue = $('.custom-text textarea').val() || ""; 
  
  // 2. Count the letters (this ignores spaces so you don't overcharge)
  var count = customTextValue.replace(/\s+/g, '').length; 

  // 3. Find your hidden "Letter Count" input from image_7b8997.png
  var hiddenInput = document.querySelector('.letter-count input');

  if (hiddenInput) {
    // 4. Use the function already in your file to update the price live
    triggerReactChangeEvent(hiddenInput, count);
  }
});